module.exports = __webpack_public_path__ + "static/img/IMG_20240324_130938.1334e558.jpg";